

import React, { memo, useState } from 'react';
import _memoize from 'lodash.memoize';

import { Image, LucideIcon as Icon, Link } from '../../../../../../../../../../../ui-kit';
import { Trash2, Pencil } from 'lucide-react';
import ContentView from '../../../../../../../../ContentView';
import { getUser } from '../../../../../../../../../../../common/utils';
import CommentAssets from '../../../../../../../../CommentAssets';
import '../styles/_reply.scss';








const handleEditComment = _memoize((
{
  commentId,
  content,
  comment: parentComment,
  editReply,
  createdByUser






}) =>
(event) => {
  if (event) {
    event.stopPropagation();
  }
  editReply({ commentId, content, parentComment, createdByUser });
});

const handleDelete = _memoize(({ commentId, comment, deleteReply }) => () => {
  deleteReply({ commentId, parentComment: comment });
});







const handleReplyToComment = _memoize((
{ userId, name, replyToComment }) =>

() => {replyToComment({ userId, name });}
);

const toggleAssets = (showAssets, setShowAssets) => () => {
  setShowAssets(!showAssets);
};














function Reply({
  editReply,
  deleteReply,
  replyToComment,
  createdByUser,
  commentId,
  assetIds,
  content,
  parentComment,
  isReadOnly,
  isResourceOwner
}) {
  const [showAssets, setShowAssets] = useState(false);
  const { userId, name, isUser, imageUrl } = getUser(createdByUser);
  const isDeletable = isResourceOwner || isUser;
  const isEditable = isUser;

  return (
    <div className="reply">
      <div className="reply__user-profile">
        <Image
          height="20px"
          width="20px"
          circular
          imageUrl={imageUrl}
          placeholderText={name}
          placeholderTextSize={9}
          backgroundSize="cover" />

        <span>{isUser ? 'You' : name}</span>
      </div>
      <ContentView content={content} />
      {
      isReadOnly ?
      null :

      <div className="reply__controls">
              {
        isUser ?
        null :

        <Link
          className="reply__controls__reply"
          button
          onClick={handleReplyToComment({ userId, name, replyToComment })}>

                  Reply
                </Link>}


              <div className="reply__controls__row">
                {assetIds && assetIds.length > 0 &&
          <Link
            className="reply__controls__assets"
            button
            onClick={toggleAssets(showAssets, setShowAssets)}>

                  {showAssets ? 'Hide' : 'Show'}
                  {' '}
                  Assets
                </Link>}

                {isEditable ?
          <Icon
            icon={Pencil}
            color="russian"
            hoverColor="darkDenim"
            size={16}
            onClick={handleEditComment({
              commentId,
              content,
              comment: parentComment,
              editReply,
              createdByUser
            })}
            wrapperClassName="reply__controls__edit-icon flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" /> :


          null}
                {
          isDeletable &&
          <Icon
            icon={Trash2}
            color="russian"
            hoverColor="redApple"
            size={16}
            onClick={handleDelete({
              deleteReply,
              comment: parentComment,
              commentId
            })}
            wrapperClassName="reply__controls__trash-icon flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-red-50" />}



              </div>
            </div>}



      {showAssets &&
      <div className="assets-wrapper">
          <CommentAssets assetIds={assetIds} commentId={commentId} />
        </div>}

    </div>);

}

export default memo(Reply);